import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import CacheKeys from '../../../cache/CacheKeys';
import CacheManager from '../../../cache/CacheManager';
import SalesContactPageUI from './SalesContactPageUI';
class SalesContactPageSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorList: null,
      salesContactList: [],
    };
  }

  render() {
    return (
      <SalesContactPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        salesContactList={this.state.salesContactList}
        onRefreshClick={this.onRefreshClick}
        
      />
    );
  }

  componentDidMount() {
    const { context } = this.props;
    this.getSalesContactList(context);
  }

  getSalesContactList(context) {

    const resource = `/api/su/sales/targets/contacts`;
    const cacheManager = new CacheManager({
        resource: resource,  // Include query parameters
        cacheKey: CacheKeys.SalesContactList(),  // Use the cache key
        callback: this.getSalesContactListCallback,
        ttlInSecs: 600,
    });

    cacheManager.getObject2(context);
}

  getSalesContactListCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      salesContactList: response.salesLeadList,
    });
  };

  onRefreshClick = () => {
    const { context } = this.props;
    CacheManager.removeObject(CacheKeys.SalesContactList());
    this.setState({
      salesContactList: null,
      errorList: null,
    });
    this.getSalesContactList(context);
  };
}

export default withRouter(SalesContactPageSF);
